function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#99E8F2",
  cx: 100,
  cy: 100,
  r: 100
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 50,
  y: 50,
  fill: "#FDB1DB",
  width: 100,
  height: 100
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 57.5,
  y: 70,
  fill: "#FFFFFF",
  width: 85,
  height: 72.5
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 50,
  y: 50,
  fill: "#EE0093",
  width: 100,
  height: 20
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 62.5,
  y: 77.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 82.5,
  y: 77.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 122.5,
  y: 77.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 102.5,
  y: 77.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 62.5,
  y: 100,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 82.5,
  y: 100,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 122.5,
  y: 100,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 102.5,
  y: 100,
  fill: "#E80081",
  width: 15,
  height: 15
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 62.5,
  y: 122.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 82.5,
  y: 122.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 122.5,
  y: 122.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 102.5,
  y: 122.5,
  fill: "#CBCBCB",
  width: 15,
  height: 15
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 130,
  cy: 60,
  r: 3.75
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 70,
  cy: 60,
  r: 3.75
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#6D6D6D",
  d: "M124.756,142.025h48.293v16.645c0,0-8.347,9.055-24.146,9.055s-24.146-9.055-24.146-9.055V142.025z"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "148.902,120.529 192.805,136.994 148.902,153.457 105,136.994 "
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#D5007F",
  points: "195,147.969 190.609,147.969 192.805,136.994 "
});

var SvgCursoPresAsignado = function SvgCursoPresAsignado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCursoPresAsignado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cursoPresAsignado.8d09b060.svg";
export { ForwardRef as ReactComponent };